// extracted by mini-css-extract-plugin
export default {"component":"CardItem_component__KdzxI","cardInfo":"CardItem_cardInfo__DNQeJ","imageContainer":"CardItem_imageContainer__P1nxw","title":"CardItem_title__OXfo8"};